<div style="min-height:84%">
  <h3 class="text-center">Configuration</h3>
  <h4 class="text-center">(Coming soon ...)</h4>
</div>
